import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { restoreSessionFromCookie, writeSession } from '../auth/session';
import { loginWithPassword, setSharedCookie, fetchMe } from '../api';
import BrandMark from '../components/BrandMark';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const from = location.state?.from || '/app';

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    setBusy(true);
    try {
      const token = await loginWithPassword(username, password);
      await setSharedCookie(token);
      const me = await fetchMe(token);
      writeSession({
        token,
        username: me.data?.user?.username || username,
        tenant: me.data?.tenant || null,
        source: 'password',
      });
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Sign-in failed.');
    } finally {
      setBusy(false);
    }
  }

  async function handleBistroSignIn() {
    setError('');
    setBusy(true);
    try {
      const session = await restoreSessionFromCookie();
      if (!session) {
        setError('No Bistro session found. Use your Bistro username and password above to open Payroll.');
        return;
      }
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Could not sign in with Bistro.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="shell">
      <BrandMark />
      <h1 className="hero-title" style={{ fontSize: '2.2rem' }}>Sign in</h1>
      <p className="lede">Use your Rebelity account. A Bistro merchant is optional — standalone workspaces are supported.</p>
      <form className="form" onSubmit={handleSubmit}>
        <label>
          Username or email
          <input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" required />
        </label>
        <label>
          Password
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
        </label>
        {error ? <p className="error">{error}</p> : null}
        <button className="btn btn-primary" type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <div className="cta-row">
        <button className="btn btn-ghost" type="button" disabled={busy} onClick={handleBistroSignIn}>
          {busy ? 'Opening payroll…' : 'Sign in via BistroAdmin'}
        </button>
        <Link className="btn btn-secondary" to="/signup">Create Payroll account</Link>
      </div>
    </div>
  );
}